import React, { useEffect, useState } from 'react';
import { Table, Popconfirm, message, Spin, Switch } from 'components/shared/AntComponent';
import { Button, Input, Select } from 'components/shared/FormComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteFilled, SearchOutlined } from 'components/shared/AntIcons';
import { EditIcon, EyeIcon } from 'assets/icons/CustomIcons';
import { getCandidateInternList, removeCandidate } from 'services/store/actions/candidateAction';
import { Empty, type TableProps } from 'antd';
import 'assets/styles/table.scss';
import { getBatchDetails } from 'services/store/actions/masterDataAction';
interface DataType {
    key: number;
    regno: string;
    fname: number;
    lname: string;
    gender: string;
    // qualification: any;
    mobile_number: string;
    email: string;
    status: any;
}

const InternCandidate: React.FC = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const { internListInfo, loading3, success2, error2, loading2 } = useSelector((state: any) => state.candidate);
    const { batchInfo, loading } = useSelector((state: any) => state.master);
    const [searchValue, setSearchValue] = useState('');
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const data = internListInfo?.AccountDetail || [];
    const totalRecords = internListInfo?.DataFinder?.totalrecords || 0;
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success2 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error2 : false;
    const [selectedBatch, setSelectedBatch] = useState('0');
    const [newReq, setNewReq] = useState(true);
    const customLocale = {
        emptyText: <Empty className="p-2" description="No Candidates Available" />, 
    };
    const batchOptions = !loading
        ? batchInfo?.BatchDetail?.map((item: any) => {
            return {
                label: item.batch_name + item.id,
                value: item.id?.toString(),
            };
        }) || []
        : [];
    batchOptions.push({ label: 'All', value: '0' });

    const navigateAddScreen = () => {
        history('/candidate/add-interviewee-candidate', {
            state: {
                title: 'Add General Intern',
                id: 2,
                cid: 0,
                option: batchOptions,
                backUrl:"/candidate/internship",
                
            },
        });
    };

    function getBatch() {
        const inputJson = {
            UserInput: {
                batch_id: 0,
            },
            DataFinder: {
                pagesize: 1000,
                currentpage: 1,
                sortbycolumn: '',
                sortby: 'desc',
                searchdata: '',
            },
        };
        dispatch(getBatchDetails(inputJson) as any);
    }

    useEffect(() => {
        getBatch();
    }, []);

    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'Reg No',
            dataIndex: 'regno',
            key: 'regno',
            align: 'left',
        },
        {
            title: 'First Name',
            dataIndex: 'fname',
            key: 'fname',
            width: 400,
        },
        {
            title: 'Last Name',
            dataIndex: 'lname',
            key: 'lname',
        },
        {
            title: 'Gender',
            dataIndex: 'gender',
            key: 'gender',
            align: 'center',
        },
        {
            title: 'Mobile No',
            dataIndex: 'mobile_number',
            key: 'mobile_number',
            align: 'center',
        },
        {
            title: 'Email ',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Submitted On',
            dataIndex: 'created_on',
            key: 'created_on',
            align: 'center',
            render: (created_on: any) => {
                const originalDate = new Date(created_on) || null;
                return <div>{internListInfo ? originalDate?.toLocaleString() : null}</div>;
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="pointer my-auto text-end pb-3" onClick={() => editQuestion(record)}>
                            <EditIcon size={34} />
                        </div>
                        <div className="text-warning pointer eye-icon me-2" onClick={() => viewDetails(record)}>
                            <EyeIcon size={20} />
                        </div>
                        <div className="my-auto delete-icon">
                            <Popconfirm title="Delete Candidate" description="Are you sure to delete this Candidate?" onConfirm={() => deleteQuestion(record)} okText="Yes" cancelText="No">
                                <DeleteFilled className="text-danger pointer del-icon" />
                            </Popconfirm>
                        </div>
                    </div>
                );
            },
        },
    ];

    const viewDetails = (val: any) => {
        history('/candidate/internship-detail', { state: { data: val } });
    };

    const editQuestion = (item: any) => {
        history('/candidate/add-interviewee-candidate', {
            state: {
                title: 'Update General Intern',
                id: 2,
                cid: item.id,
                option: batchOptions,
                backUrl:"/candidate/internship"
            },
        });
    };

    const deleteQuestion = (item: any) => {
        dispatch(removeCandidate(item.id) as any);
        setShowSuccessmsg(true);
        setShowErrormsg(true);
    };

    useEffect(() => {
        if (successmsg) {
            message.success('Candidate Deleted Successfully');
            setShowSuccessmsg(false);
            setPageIndex(1);
            setSearchValue('');
            getCandidate(pageSize, 1, '', selectedBatch, newReq);
        }
        if (errormsg) {
            message.error("Candidate Couldn't be deleted");
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    function getCandidate(pageSize: number, pageIndex: number, search: string, batch: any, flag: boolean) {
        const inputJson = {
            Input: {
                status: 'Active',
                candidate_type: 2,
                batch_id: Number(batch) || 0,
                project_id: 0,
                "batch_associated_flag": !flag,
            },
            DataFinder: {
                pagesize: pageSize,
                currentpage: pageIndex,
                sortbycolumn: '',
                sortby: 'asc',
                searchdata: search || '',
            },
        };
        dispatch(getCandidateInternList(inputJson) as any);
    }

    useEffect(() => {
        getCandidate(pageSize, pageIndex, searchValue, selectedBatch, newReq);
    }, []);

    const paginationConfig: TableProps<DataType>['pagination'] = {
        position: ['bottomRight'],
        current: pageIndex,
        pageSize: pageSize,
        total: totalRecords,
        onChange: (page: number, pageSize: number) => {
            setPageIndex(page);
            setPageSize(pageSize);
            getCandidate(pageSize, page, searchValue, selectedBatch, newReq);
        },
        itemRender: (current: any, type: string, originalElement: any) => {
            if (type === 'prev') {
                return <Button className="prev-btn">Previous</Button>;
            }
            if (type === 'next') {
                return <Button className="next-btn">Next</Button>;
            }
            return originalElement;
        },
    };
    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getCandidate(pageSize, 1, e.target.value, selectedBatch, newReq);
        }
    };
    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getCandidate(pageSize, 1, e.target.value, selectedBatch, newReq);
        }
    };
    const searchbyBtn = () => {
        setPageIndex(1);
        setPageIndex(1);
        getCandidate(pageSize, 1, searchValue, selectedBatch, newReq);
    };
    const handleBatchChange = (e: any) => {
        setSelectedBatch(e);
        setPageIndex(1);
        getCandidate(pageSize, 1, searchValue, e, newReq);
    };
    const changeRushOrder = (e: any) => {
        setNewReq(e);
        if (e == true) {
            setSelectedBatch('All');
        }
        getCandidate(pageSize, 1, searchValue, e ? 'All' : selectedBatch, e);
    }

    return (
        <div className="my-3">
            <div className="row m-0">
                <h5 className="col-md-3 text-start text-secondary fw-bold my-auto">Internship List</h5>
                <div className="col-md-6 ms-auto pe-1">
                    <div className="row m-0">
                        <div className="me-2 my-auto col-auto ms-auto">
                            <Switch size="small" className="me-2" defaultChecked={newReq} onChange={changeRushOrder} />
                            <span className="fs-16">New Candidate</span>
                        </div>
                        <div className="col-md-3 pe-0">
                            <Input
                                onKeyDown={(e) => handleSearch(e)}
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyUp={(e) => resetSearch(e)}
                                prefix={<SearchOutlined onClick={() => searchbyBtn()} />}
                                placeholder="Search"
                            />
                        </div>
                        <div className="col-md-3 pe-0">
                            <Select
                                className="col-md-12"
                                options={batchOptions}
                                defaultValue={selectedBatch}
                                value={selectedBatch}
                                disabled={newReq}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input: any, option: any) => {
                                    return option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }}
                                filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                onChange={(e) => handleBatchChange(e)}
                                notFoundContent={
                                    <div className="text-center p-4">
                                        {loading ? (
                                            <span>
                                                {/* <LoadingOutlined /> */}
                                                Loading...
                                            </span>
                                        ) : (
                                            <span>No batch available</span>
                                        )}
                                    </div>
                                }
                            ></Select>
                        </div>
                        <div className="col-auto text-start pe-1">
                            <Button type="primary" onClick={navigateAddScreen} className="bg-primary">
                                Add
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-2 custom-table">
                <Spin spinning={loading2} className="text-danger" tip="Deleting...">
                    <Table columns={columns} dataSource={data} rowKey="id" loading={loading3} pagination={paginationConfig} locale={customLocale} />
                </Spin>
            </div>
        </div>
    );
};

export default InternCandidate;
